import type { SelectPrefixOption } from "./Input.SelectPrefix";

export const CURRENCY_OPTIONS: SelectPrefixOption[] = [
  { value: "USD", label: "United States", icon: "🇺🇸", searchTerms: "United States" },
  { value: "AFN", label: "Afghanistan", icon: "🇦🇫", searchTerms: "Afghanistan" },
  { value: "ALL", label: "Albania", icon: "🇦🇱", searchTerms: "Albania" },
  { value: "DZD", label: "Algeria", icon: "🇩🇿", searchTerms: "Algeria" },
  { value: "ARS", label: "Argentina", icon: "🇦🇷", searchTerms: "Argentina" },
  { value: "AUD", label: "Australia", icon: "🇦🇺", searchTerms: "Australia" },
  { value: "BSD", label: "Bahamas", icon: "🇧🇸", searchTerms: "Bahamas" },
  { value: "BHD", label: "Bahrain", icon: "🇧🇭", searchTerms: "Bahrain" },
  { value: "BDT", label: "Bangladesh", icon: "🇧🇩", searchTerms: "Bangladesh" },
  { value: "BBD", label: "Barbados", icon: "🇧🇧", searchTerms: "Barbados" },
  { value: "BZD", label: "Belize", icon: "🇧🇿", searchTerms: "Belize" },
  { value: "BOB", label: "Bolivia", icon: "🇧🇴", searchTerms: "Bolivia" },
  { value: "BRL", label: "Brazil", icon: "🇧🇷", searchTerms: "Brazil" },
  { value: "CAD", label: "Canada", icon: "🇨🇦", searchTerms: "Canada" },
  { value: "CLP", label: "Chile", icon: "🇨🇱", searchTerms: "Chile" },
  { value: "CNY", label: "China", icon: "🇨🇳", searchTerms: "China" },
  { value: "COP", label: "Colombia", icon: "🇨🇴", searchTerms: "Colombia" },
  { value: "CRC", label: "Costa Rica", icon: "🇨🇷", searchTerms: "Costa Rica" },
  { value: "CUP", label: "Cuba", icon: "🇨🇺", searchTerms: "Cuba" },
  { value: "CZK", label: "Czechia", icon: "🇨🇿", searchTerms: "Czechia" },
  { value: "DKK", label: "Denmark", icon: "🇩🇰", searchTerms: "Denmark" },
  { value: "DOP", label: "Dominican Republic", icon: "🇩🇴", searchTerms: "Dominican Republic" },
  { value: "EGP", label: "Egypt", icon: "🇪🇬", searchTerms: "Egypt" },
  { value: "ETB", label: "Ethiopia", icon: "🇪🇹", searchTerms: "Ethiopia" },
  { value: "EUR", label: "European Union", icon: "🇪🇺", searchTerms: "Europe" },
  { value: "GHS", label: "Ghana", icon: "🇬🇭", searchTerms: "Ghana" },
  { value: "GTQ", label: "Guatemala", icon: "🇬🇹", searchTerms: "Guatemala" },
  { value: "GYD", label: "Guyana", icon: "🇬🇾", searchTerms: "Guyana" },
  { value: "HTG", label: "Haiti", icon: "🇭🇹", searchTerms: "Haiti" },
  { value: "HNL", label: "Honduras", icon: "🇭🇳", searchTerms: "Honduras" },
  { value: "HKD", label: "Hong Kong", icon: "🇭🇰", searchTerms: "Hong Kong" },
  { value: "HUF", label: "Hungary", icon: "🇭🇺", searchTerms: "Hungary" },
  { value: "INR", label: "India", icon: "🇮🇳", searchTerms: "India" },
  { value: "IDR", label: "Indonesia", icon: "🇮🇩", searchTerms: "Indonesia" },
  { value: "ILS", label: "Israel", icon: "🇮🇱", searchTerms: "Israel" },
  { value: "JMD", label: "Jamaica", icon: "🇯🇲", searchTerms: "Jamaica" },
  { value: "JPY", label: "Japan", icon: "🇯🇵", searchTerms: "Japan" },
  { value: "JOD", label: "Jordan", icon: "🇯🇴", searchTerms: "Jordan" },
  { value: "KES", label: "Kenya", icon: "🇰🇪", searchTerms: "Kenya" },
  { value: "KWD", label: "Kuwait", icon: "🇰🇼", searchTerms: "Kuwait" },
  { value: "LBP", label: "Lebanon", icon: "🇱🇧", searchTerms: "Lebanon" },
  { value: "MYR", label: "Malaysia", icon: "🇲🇾", searchTerms: "Malaysia" },
  { value: "MXN", label: "Mexico", icon: "🇲🇽", searchTerms: "Mexico" },
  { value: "NZD", label: "New Zealand", icon: "🇳🇿", searchTerms: "New Zealand" },
  { value: "NIO", label: "Nicaragua", icon: "🇳🇮", searchTerms: "Nicaragua" },
  { value: "NGN", label: "Nigeria", icon: "🇳🇬", searchTerms: "Nigeria" },
  { value: "NOK", label: "Norway", icon: "🇳🇴", searchTerms: "Norway" },
  { value: "OMR", label: "Oman", icon: "🇴🇲", searchTerms: "Oman" },
  { value: "PKR", label: "Pakistan", icon: "🇵🇰", searchTerms: "Pakistan" },
  { value: "PAB", label: "Panama", icon: "🇵🇦", searchTerms: "Panama" },
  { value: "PYG", label: "Paraguay", icon: "🇵🇾", searchTerms: "Paraguay" },
  { value: "PEN", label: "Peru", icon: "🇵🇪", searchTerms: "Peru" },
  { value: "PHP", label: "Philippines", icon: "🇵🇭", searchTerms: "Philippines" },
  { value: "PLN", label: "Poland", icon: "🇵🇱", searchTerms: "Poland" },
  { value: "QAR", label: "Qatar", icon: "🇶🇦", searchTerms: "Qatar" },
  { value: "RON", label: "Romania", icon: "🇷🇴", searchTerms: "Romania" },
  { value: "RUB", label: "Russia", icon: "🇷🇺", searchTerms: "Russia" },
  { value: "XCD", label: "Saint Lucia", icon: "🇱🇨", searchTerms: "Saint Lucia" },
  { value: "SAR", label: "Saudi Arabia", icon: "🇸🇦", searchTerms: "Saudi Arabia" },
  { value: "SGD", label: "Singapore", icon: "🇸🇬", searchTerms: "Singapore" },
  { value: "ZAR", label: "South Africa", icon: "🇿🇦", searchTerms: "South Africa" },
  { value: "KRW", label: "South Korea", icon: "🇰🇷", searchTerms: "South Korea" },
  { value: "SRD", label: "Suriname", icon: "🇸🇷", searchTerms: "Suriname" },
  { value: "SEK", label: "Sweden", icon: "🇸🇪", searchTerms: "Sweden" },
  { value: "CHF", label: "Switzerland", icon: "🇨🇭", searchTerms: "Switzerland" },
  { value: "TWD", label: "Taiwan", icon: "🇹🇼", searchTerms: "Taiwan" },
  { value: "TZS", label: "Tanzania", icon: "🇹🇿", searchTerms: "Tanzania" },
  { value: "THB", label: "Thailand", icon: "🇹🇭", searchTerms: "Thailand" },
  { value: "TTD", label: "Trinidad and Tobago", icon: "🇹🇹", searchTerms: "Trinidad and Tobago" },
  { value: "TRY", label: "Turkey", icon: "🇹🇷", searchTerms: "Turkey" },
  { value: "UGX", label: "Uganda", icon: "🇺🇬", searchTerms: "Uganda" },
  { value: "AED", label: "United Arab Emirates", icon: "🇦🇪", searchTerms: "United Arab Emirates" },
  { value: "GBP", label: "United Kingdom", icon: "🇬🇧", searchTerms: "United Kingdom" },
  { value: "UYU", label: "Uruguay", icon: "🇺🇾", searchTerms: "Uruguay" },
  { value: "VES", label: "Venezuela", icon: "🇻🇪", searchTerms: "Venezuela" },
  { value: "VND", label: "Vietnam", icon: "🇻🇳", searchTerms: "Vietnam" }
];

export const COUNTRY_CODES: SelectPrefixOption[] = [
  { value: "+1", label: "United States", icon: "🇺🇸", searchTerms: "United States" },
  { value: "+93", label: "Afghanistan", icon: "🇦🇫", searchTerms: "Afghanistan" },
  { value: "+355", label: "Albania", icon: "🇦🇱", searchTerms: "Albania" },
  { value: "+213", label: "Algeria", icon: "🇩🇿", searchTerms: "Algeria" },
  { value: "+376", label: "Andorra", icon: "🇦🇩", searchTerms: "Andorra" },
  { value: "+244", label: "Angola", icon: "🇦🇴", searchTerms: "Angola" },
  { value: "+374", label: "Armenia", icon: "🇦🇲", searchTerms: "Armenia" },
  { value: "+297", label: "Aruba", icon: "🇦🇼", searchTerms: "Aruba" },
  { value: "+61", label: "Australia", icon: "🇦🇺", searchTerms: "Australia" },
  { value: "+43", label: "Austria", icon: "🇦🇹", searchTerms: "Austria" },
  { value: "+994", label: "Azerbaijan", icon: "🇦🇿", searchTerms: "Azerbaijan" },
  { value: "+973", label: "Bahrain", icon: "🇧🇭", searchTerms: "Bahrain" },
  { value: "+880", label: "Bangladesh", icon: "🇧🇩", searchTerms: "Bangladesh" },
  { value: "+375", label: "Belarus", icon: "🇧🇾", searchTerms: "Belarus" },
  { value: "+32", label: "Belgium", icon: "🇧🇪", searchTerms: "Belgium" },
  { value: "+501", label: "Belize", icon: "🇧🇿", searchTerms: "Belize" },
  { value: "+229", label: "Benin", icon: "🇧🇯", searchTerms: "Benin" },
  { value: "+975", label: "Bhutan", icon: "🇧🇹", searchTerms: "Bhutan" },
  { value: "+591", label: "Bolivia", icon: "🇧🇴", searchTerms: "Bolivia" },
  { value: "+387", label: "Bosnia and Herzegovina", icon: "🇧🇦", searchTerms: "Bosnia and Herzegovina" },
  { value: "+267", label: "Botswana", icon: "🇧🇼", searchTerms: "Botswana" },
  { value: "+55", label: "Brazil", icon: "🇧🇷", searchTerms: "Brazil" },
  { value: "+673", label: "Brunei", icon: "🇧🇳", searchTerms: "Brunei" },
  { value: "+359", label: "Bulgaria", icon: "🇧🇬", searchTerms: "Bulgaria" },
  { value: "+226", label: "Burkina Faso", icon: "🇧🇫", searchTerms: "Burkina Faso" },
  { value: "+257", label: "Burundi", icon: "🇧🇮", searchTerms: "Burundi" },
  { value: "+855", label: "Cambodia", icon: "🇰🇭", searchTerms: "Cambodia" },
  { value: "+237", label: "Cameroon", icon: "🇨🇲", searchTerms: "Cameroon" },
  { value: "+1", label: "Canada", icon: "🇨🇦", searchTerms: "Canada" },
  { value: "+238", label: "Cape Verde", icon: "🇨🇻", searchTerms: "Cape Verde" },
  { value: "+236", label: "Central African Republic", icon: "🇨🇫", searchTerms: "Central African Republic" },
  { value: "+235", label: "Chad", icon: "🇹🇩", searchTerms: "Chad" },
  { value: "+56", label: "Chile", icon: "🇨🇱", searchTerms: "Chile" },
  { value: "+86", label: "China", icon: "🇨🇳", searchTerms: "China" },
  { value: "+57", label: "Colombia", icon: "🇨🇴", searchTerms: "Colombia" },
  { value: "+269", label: "Comoros", icon: "🇰🇲", searchTerms: "Comoros" },
  { value: "+682", label: "Cook Islands", icon: "🇨🇰", searchTerms: "Cook Islands" },
  { value: "+506", label: "Costa Rica", icon: "🇨🇷", searchTerms: "Costa Rica" },
  { value: "+385", label: "Croatia", icon: "🇭🇷", searchTerms: "Croatia" },
  { value: "+53", label: "Cuba", icon: "🇨🇺", searchTerms: "Cuba" },
  { value: "+357", label: "Cyprus", icon: "🇨🇾", searchTerms: "Cyprus" },
  { value: "+420", label: "Czech Republic", icon: "🇨🇿", searchTerms: "Czech Republic" },
  { value: "+243", label: "Democratic Republic of the Congo", icon: "🇨🇩", searchTerms: "Democratic Republic of the Congo" },
  { value: "+45", label: "Denmark", icon: "🇩🇰", searchTerms: "Denmark" },
  { value: "+253", label: "Djibouti", icon: "🇩🇯", searchTerms: "Djibouti" },
  { value: "+670", label: "East Timor", icon: "🇹🇱", searchTerms: "East Timor" },
  { value: "+593", label: "Ecuador", icon: "🇪🇨", searchTerms: "Ecuador" },
  { value: "+20", label: "Egypt", icon: "🇪🇬", searchTerms: "Egypt" },
  { value: "+503", label: "El Salvador", icon: "🇸🇻", searchTerms: "El Salvador" },
  { value: "+240", label: "Equatorial Guinea", icon: "🇬🇶", searchTerms: "Equatorial Guinea" },
  { value: "+291", label: "Eritrea", icon: "🇪🇷", searchTerms: "Eritrea" },
  { value: "+372", label: "Estonia", icon: "🇪🇪", searchTerms: "Estonia" },
  { value: "+268", label: "Eswatini", icon: "🇸🇿", searchTerms: "Eswatini swaziland" },
  { value: "+251", label: "Ethiopia", icon: "🇪🇹", searchTerms: "Ethiopia" },
  { value: "+500", label: "Falkland Islands", icon: "🇫🇰", searchTerms: "Falkland Islands" },
  { value: "+298", label: "Faroe Islands", icon: "🇫🇴", searchTerms: "Faroe Islands" },
  { value: "+679", label: "Fiji", icon: "🇫🇯", searchTerms: "Fiji" },
  { value: "+358", label: "Finland", icon: "🇫🇮", searchTerms: "Finland" },
  { value: "+33", label: "France", icon: "🇫🇷", searchTerms: "France" },
  { value: "+689", label: "French Polynesia", icon: "🇵🇫", searchTerms: "French Polynesia Tahiti" },
  { value: "+241", label: "Gabon", icon: "🇬🇦", searchTerms: "Gabon" },
  { value: "+220", label: "Gambia", icon: "🇬🇲", searchTerms: "Gambia" },
  { value: "+995", label: "Georgia", icon: "🇬🇪", searchTerms: "Georgia" },
  { value: "+49", label: "Germany", icon: "🇩🇪", searchTerms: "Germany" },
  { value: "+233", label: "Ghana", icon: "🇬🇭", searchTerms: "Ghana" },
  { value: "+350", label: "Gibraltar", icon: "🇬🇮", searchTerms: "Gibraltar" },
  { value: "+30", label: "Greece", icon: "🇬🇷", searchTerms: "Greece" },
  { value: "+299", label: "Greenland", icon: "🇬🇱", searchTerms: "Greenland" },
  { value: "+590", label: "Guadeloupe", icon: "🇬🇵", searchTerms: "Guadeloupe" },
  { value: "+502", label: "Guatemala", icon: "🇬🇹", searchTerms: "Guatemala" },
  { value: "+224", label: "Guinea", icon: "🇬🇳", searchTerms: "Guinea" },
  { value: "+245", label: "Guinea-Bissau", icon: "🇬🇼", searchTerms: "Guinea-Bissau" },
  { value: "+592", label: "Guyana", icon: "🇬🇾", searchTerms: "Guyana" },
  { value: "+509", label: "Haiti", icon: "🇭🇹", searchTerms: "Haiti" },
  { value: "+504", label: "Honduras", icon: "🇭🇳", searchTerms: "Honduras" },
  { value: "+852", label: "Hong Kong", icon: "🇭🇰", searchTerms: "Hong Kong" },
  { value: "+36", label: "Hungary", icon: "🇭🇺", searchTerms: "Hungary" },
  { value: "+354", label: "Iceland", icon: "🇮🇸", searchTerms: "Iceland" },
  { value: "+91", label: "India", icon: "🇮🇳", searchTerms: "India" },
  { value: "+62", label: "Indonesia", icon: "🇮🇩", searchTerms: "Indonesia" },
  { value: "+98", label: "Iran", icon: "🇮🇷", searchTerms: "Iran" },
  { value: "+964", label: "Iraq", icon: "🇮🇶", searchTerms: "Iraq" },
  { value: "+353", label: "Ireland", icon: "🇮🇪", searchTerms: "Ireland" },
  { value: "+972", label: "Israel", icon: "🇮🇱", searchTerms: "Israel" },
  { value: "+39", label: "Italy", icon: "🇮🇹", searchTerms: "Italy" },
  { value: "+225", label: "Ivory Coast", icon: "🇨🇮", searchTerms: "Ivory Coast" },
  { value: "+81", label: "Japan", icon: "🇯🇵", searchTerms: "Japan" },
  { value: "+962", label: "Jordan", icon: "🇯🇴", searchTerms: "Jordan" },
  { value: "+254", label: "Kenya", icon: "🇰🇪", searchTerms: "Kenya" },
  { value: "+686", label: "Kiribati", icon: "🇰🇮", searchTerms: "Kiribati" },
  { value: "+383", label: "Kosovo", icon: "🇽🇰", searchTerms: "Kosovo" },
  { value: "+965", label: "Kuwait", icon: "🇰🇼", searchTerms: "Kuwait" },
  { value: "+996", label: "Kyrgyzstan", icon: "🇰🇬", searchTerms: "Kyrgyzstan" },
  { value: "+856", label: "Laos", icon: "🇱🇦", searchTerms: "Laos" },
  { value: "+371", label: "Latvia", icon: "🇱🇻", searchTerms: "Latvia" },
  { value: "+961", label: "Lebanon", icon: "🇱🇧", searchTerms: "Lebanon" },
  { value: "+266", label: "Lesotho", icon: "🇱🇸", searchTerms: "Lesotho" },
  { value: "+231", label: "Liberia", icon: "🇱🇷", searchTerms: "Liberia" },
  { value: "+218", label: "Libya", icon: "🇱🇾", searchTerms: "Libya" },
  { value: "+423", label: "Liechtenstein", icon: "🇱🇮", searchTerms: "Liechtenstein" },
  { value: "+370", label: "Lithuania", icon: "🇱🇹", searchTerms: "Lithuania" },
  { value: "+352", label: "Luxembourg", icon: "🇱🇺", searchTerms: "Luxembourg" },
  { value: "+853", label: "Macau", icon: "🇲🇴", searchTerms: "Macau Macao" },
  { value: "+261", label: "Madagascar", icon: "🇲🇬", searchTerms: "Madagascar" },
  { value: "+265", label: "Malawi", icon: "🇲🇼", searchTerms: "Malawi" },
  { value: "+60", label: "Malaysia", icon: "🇲🇾", searchTerms: "Malaysia" },
  { value: "+960", label: "Maldives", icon: "🇲🇻", searchTerms: "Maldives" },
  { value: "+223", label: "Mali", icon: "🇲🇱", searchTerms: "Mali" },
  { value: "+356", label: "Malta", icon: "🇲🇹", searchTerms: "Malta" },
  { value: "+692", label: "Marshall Islands", icon: "🇲🇭", searchTerms: "Marshall Islands" },
  { value: "+596", label: "Martinique", icon: "🇲🇶", searchTerms: "Martinique" },
  { value: "+222", label: "Mauritania", icon: "🇲🇷", searchTerms: "Mauritania" },
  { value: "+230", label: "Mauritius", icon: "🇲🇺", searchTerms: "Mauritius" },
  { value: "+52", label: "Mexico", icon: "🇲🇽", searchTerms: "Mexico" },
  { value: "+691", label: "Micronesia", icon: "🇫🇲", searchTerms: "Micronesia" },
  { value: "+373", label: "Moldova", icon: "🇲🇩", searchTerms: "Moldova" },
  { value: "+377", label: "Monaco", icon: "🇲🇨", searchTerms: "Monaco" },
  { value: "+976", label: "Mongolia", icon: "🇲🇳", searchTerms: "Mongolia" },
  { value: "+382", label: "Montenegro", icon: "🇲🇪", searchTerms: "Montenegro" },
  { value: "+212", label: "Morocco", icon: "🇲🇦", searchTerms: "Morocco" },
  { value: "+258", label: "Mozambique", icon: "🇲🇿", searchTerms: "Mozambique" },
  { value: "+95", label: "Myanmar", icon: "🇲🇲", searchTerms: "Myanmar" },
  { value: "+264", label: "Namibia", icon: "🇳🇦", searchTerms: "Namibia" },
  { value: "+674", label: "Nauru", icon: "🇳🇷", searchTerms: "Nauru" },
  { value: "+977", label: "Nepal", icon: "🇳🇵", searchTerms: "Nepal" },
  { value: "+31", label: "Netherlands", icon: "🇳🇱", searchTerms: "Netherlands" },
  { value: "+599", label: "Netherlands Antilles", icon: "🇧🇶", searchTerms: "Netherlands Antilles" },
  { value: "+687", label: "New Caledonia", icon: "🇳🇨", searchTerms: "New Caledonia" },
  { value: "+64", label: "New Zealand", icon: "🇳🇿", searchTerms: "New Zealand" },
  { value: "+505", label: "Nicaragua", icon: "🇳🇮", searchTerms: "Nicaragua" },
  { value: "+227", label: "Niger", icon: "🇳🇪", searchTerms: "Niger" },
  { value: "+234", label: "Nigeria", icon: "🇳🇬", searchTerms: "Nigeria" },
  { value: "+672", label: "Norfolk Island", icon: "🇳🇫", searchTerms: "Norfolk Island" },
  { value: "+850", label: "North Korea", icon: "🇰🇵", searchTerms: "North Korea DPRK" },
  { value: "+389", label: "North Macedonia", icon: "🇲🇰", searchTerms: "North Macedonia" },
  { value: "+47", label: "Norway", icon: "🇳🇴", searchTerms: "Norway" },
  { value: "+968", label: "Oman", icon: "🇴🇲", searchTerms: "Oman" },
  { value: "+92", label: "Pakistan", icon: "🇵🇰", searchTerms: "Pakistan" },
  { value: "+680", label: "Palau", icon: "🇵🇼", searchTerms: "Palau" },
  { value: "+970", label: "Palestine", icon: "🇵🇸", searchTerms: "Palestine" },
  { value: "+507", label: "Panama", icon: "🇵🇦", searchTerms: "Panama" },
  { value: "+675", label: "Papua New Guinea", icon: "🇵🇬", searchTerms: "Papua New Guinea" },
  { value: "+595", label: "Paraguay", icon: "🇵🇾", searchTerms: "Paraguay" },
  { value: "+51", label: "Peru", icon: "🇵🇪", searchTerms: "Peru" },
  { value: "+63", label: "Philippines", icon: "🇵🇭", searchTerms: "Philippines" },
  { value: "+48", label: "Poland", icon: "🇵🇱", searchTerms: "Poland" },
  { value: "+351", label: "Portugal", icon: "🇵🇹", searchTerms: "Portugal" },
  { value: "+974", label: "Qatar", icon: "🇶🇦", searchTerms: "Qatar" },
  { value: "+242", label: "Republic of the Congo", icon: "🇨🇬", searchTerms: "Republic of the Congo" },
  { value: "+40", label: "Romania", icon: "🇷🇴", searchTerms: "Romania" },
  { value: "+7", label: "Russia", icon: "🇷🇺", searchTerms: "Russia" },
  { value: "+250", label: "Rwanda", icon: "🇷🇼", searchTerms: "Rwanda" },
  { value: "+290", label: "Saint Helena", icon: "🇸🇭", searchTerms: "Saint Helena" },
  { value: "+508", label: "Saint Pierre and Miquelon", icon: "🇵🇲", searchTerms: "Saint Pierre and Miquelon" },
  { value: "+685", label: "Samoa", icon: "🇼🇸", searchTerms: "Western Samoa" },
  { value: "+378", label: "San Marino", icon: "🇸🇲", searchTerms: "San Marino" },
  { value: "+239", label: "São Tomé and Príncipe", icon: "🇸🇹", searchTerms: "São Tomé and Príncipe" },
  { value: "+966", label: "Saudi Arabia", icon: "🇸🇦", searchTerms: "Saudi Arabia KSA" },
  { value: "+221", label: "Senegal", icon: "🇸🇳", searchTerms: "Senegal" },
  { value: "+381", label: "Serbia", icon: "🇷🇸", searchTerms: "Serbia" },
  { value: "+248", label: "Seychelles", icon: "🇸🇨", searchTerms: "Seychelles" },
  { value: "+232", label: "Sierra Leone", icon: "🇸🇱", searchTerms: "Sierra Leone" },
  { value: "+65", label: "Singapore", icon: "🇸🇬", searchTerms: "Singapore" },
  { value: "+421", label: "Slovakia", icon: "🇸🇰", searchTerms: "Slovakia" },
  { value: "+386", label: "Slovenia", icon: "🇸🇮", searchTerms: "Slovenia" },
  { value: "+677", label: "Solomon Islands", icon: "🇸🇧", searchTerms: "Solomon Islands" },
  { value: "+252", label: "Somalia", icon: "🇸🇴", searchTerms: "Somalia" },
  { value: "+27", label: "South Africa", icon: "🇿🇦", searchTerms: "South Africa" },
  { value: "+82", label: "South Korea", icon: "🇰🇷", searchTerms: "South Korea" },
  { value: "+34", label: "Spain", icon: "🇪🇸", searchTerms: "Spain" },
  { value: "+94", label: "Sri Lanka", icon: "🇱🇰", searchTerms: "Sri Lanka" },
  { value: "+249", label: "Sudan", icon: "🇸🇩", searchTerms: "Sudan" },
  { value: "+597", label: "Suriname", icon: "🇸🇷", searchTerms: "Suriname" },
  { value: "+46", label: "Sweden", icon: "🇸🇪", searchTerms: "Sweden" },
  { value: "+41", label: "Switzerland", icon: "🇨🇭", searchTerms: "Switzerland" },
  { value: "+963", label: "Syria", icon: "🇸🇾", searchTerms: "Syria" },
  { value: "+886", label: "Taiwan", icon: "🇹🇼", searchTerms: "Taiwan" },
  { value: "+992", label: "Tajikistan", icon: "🇹🇯", searchTerms: "Tajikistan" },
  { value: "+255", label: "Tanzania", icon: "🇹🇿", searchTerms: "Tanzania" },
  { value: "+66", label: "Thailand", icon: "🇹🇭", searchTerms: "Thailand" },
  { value: "+228", label: "Togo", icon: "🇹🇬", searchTerms: "Togo" },
  { value: "+690", label: "Tokelau", icon: "🇹🇰", searchTerms: "Tokelau" },
  { value: "+676", label: "Tonga", icon: "🇹🇴", searchTerms: "Tonga" },
  { value: "+216", label: "Tunisia", icon: "🇹🇳", searchTerms: "Tunisia" },
  { value: "+90", label: "Turkey", icon: "🇹🇷", searchTerms: "Turkey" },
  { value: "+993", label: "Turkmenistan", icon: "🇹🇲", searchTerms: "Turkmenistan" },
  { value: "+688", label: "Tuvalu", icon: "🇹🇻", searchTerms: "Tuvalu" },
  { value: "+256", label: "Uganda", icon: "🇺🇬", searchTerms: "Uganda" },
  { value: "+380", label: "Ukraine", icon: "🇺🇦", searchTerms: "Ukraine" },
  { value: "+971", label: "United Arab Emirates", icon: "🇦🇪", searchTerms: "UAE Dubai Abu Dhabi" },
  { value: "+44", label: "United Kingdom", icon: "🇬🇧", searchTerms: "United Kingdom" },
  { value: "+598", label: "Uruguay", icon: "🇺🇾", searchTerms: "Uruguay" },
  { value: "+998", label: "Uzbekistan", icon: "🇺🇿", searchTerms: "Uzbekistan" },
  { value: "+678", label: "Vanuatu", icon: "🇻🇺", searchTerms: "Vanuatu" },
  { value: "+58", label: "Venezuela", icon: "🇻🇪", searchTerms: "Venezuela" },
  { value: "+84", label: "Vietnam", icon: "🇻🇳", searchTerms: "Vietnam" },
  { value: "+967", label: "Yemen", icon: "🇾🇪", searchTerms: "Yemen" },
  { value: "+260", label: "Zambia", icon: "🇿🇲", searchTerms: "Zambia" },
  { value: "+263", label: "Zimbabwe", icon: "🇿🇼", searchTerms: "Zimbabwe" }
];
